import { useId, type InputHTMLAttributes } from 'react';
import { FormError } from './FormError';
import './ui.css';

interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string;
  error?: string | null;
  hint?: string;
}

export function TextField({ label, error, hint, className, ...rest }: TextFieldProps) {
  const generatedId = useId();
  const errorId = `${generatedId}-error`;
  const hintId = `${generatedId}-hint`;
  const describedBy = [error ? errorId : '', hint ? hintId : ''].filter(Boolean).join(' ');

  return (
    <div className="ui-field">
      <label className="ui-field__label" htmlFor={generatedId}>
        {label}
      </label>
      <input
        id={generatedId}
        className={[
          'ui-field__control',
          error ? 'ui-field__control--error' : '',
          className ?? '',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy || undefined}
        {...rest}
      />
      {hint ? (
        <span id={hintId} className="ui-field__hint">
          {hint}
        </span>
      ) : null}
      <FormError id={errorId} message={error} />
    </div>
  );
}
